// first two entries are pushed by offset

export const getGameEntries = async () => {
	return [
		{
			database_id: "pr_kd_14x28",
			photo: (await import("assets/images/games/kids.jpg")).default,
			mobilePhoto: (await import("assets/images/games/mobile_kids.jpg")).default,
			name: "Kids",
		},
		{
			database_id: "mm_kd_14x28",
			photo: (await import("assets/images/games/memory.png")).default,
			mobilePhoto: (await import("assets/images/games/memory.png")).default,
			name: "Memory Kids",
		},
		{
			database_id: "pr_i_14x28",
			photo: (await import("assets/images/games/indiana.png")).default,
			mobilePhoto: (await import("assets/images/games/indiana.png")).default,
			name: "Indiana",
		},
		{
			database_id: "pr_dt_14x28",
			photo: (await import("assets/images/games/double_trouble.png")).default,
			mobilePhoto: (await import("assets/images/games/double_trouble.png")).default,
			name: "Double Trouble",
		},
		{
			database_id: "ev_14x28",
			photo: (await import("assets/images/games/red_alert.png")).default,
			mobilePhoto: (await import("assets/images/games/red_alert.png")).default,
			name: "Red Alert",
			shouldMilisecondsBeReversed: true,
		},
		{
			database_id: "pr_mystery_14x28",
			photo: (await import("assets/images/games/mystery.jpg")).default,
			mobilePhoto: (await import("assets/images/games/mobile_mystery.jpg")).default,
			name: "Mystery",
		},
		{
			database_id: "pr_sw_14x28",
			photo: (await import("assets/images/games/pixel_switch.jpg")).default,
			mobilePhoto: (await import("assets/images/games/mobile_pixel_switch.jpg")).default,
			name: "Let's Switch!",
			shouldCountPoints: true,
		},
		{
			database_id: "pr_ekd_14x28",
			photo: (await import("assets/images/games/easy_kids.jpg")).default,
			mobilePhoto: (await import("assets/images/games/mobile_easy_kids.jpg")).default,
			name: "Easy Kids",
		},
		{
			database_id: "mm_14x28",
			photo: (await import("assets/images/games/memory.png")).default,
			mobilePhoto: (await import("assets/images/games/memory.png")).default,
			name: "Memory",
		},
		{
			database_id: "pr_bg_14x28",
			photo: (await import("assets/images/games/begins.jpg")).default,
			mobilePhoto: (await import("assets/images/games/mobile_begins.jpg")).default,
			name: "Begins",
		},
		{
			database_id: "pr_bk_14x28",
			photo: (await import("assets/images/games/blue_keys.jpg")).default,
			mobilePhoto: (await import("assets/images/games/mobile_blue_keys.jpg")).default,
			name: "Blue Keys",
		},
		{
			database_id: "pr_frg_14x28",
			photo: (await import("assets/images/games/frogs.png")).default,
			mobilePhoto: (await import("assets/images/games/frogs.png")).default,
			name: "Frogs",
		},
		{
			database_id: "pr_qtr_14x28",
			photo: (await import("assets/images/games/quatro.png")).default,
			mobilePhoto: (await import("assets/images/games/quatro.png")).default,
			name: "Quatro",
		},
		{
			database_id: "pr_trio_14x28",
			photo: (await import("assets/images/games/trio.jpg")).default,
			mobilePhoto: (await import("assets/images/games/mobile_trio.jpg")).default,
			name: "Trio",
		},
	];
};
